import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import MultiFactorAuthentication, {
  SubmitValue,
  Props,
} from './MultiFactorAuthentication';
import mfaEnabled from '../../actions/setters/mfaEnabled';

const MultiFactorAuthenticationContainer = reduxForm<SubmitValue, Props>({
  form: 'MultiFactorAuthentication',
})(MultiFactorAuthentication);

export default connect(null, { submitHandler: mfaEnabled })(
  MultiFactorAuthenticationContainer,
);
